import { BaseModel } from 'app/core/models';
import { TranslationService } from 'app/core/services';

export const enumToArray = (base: any, translationService?: TranslationService): BaseModel[] => {
    const keys = Object.keys(base);

    return keys
        .filter(item => isNaN(Number(item)) && item !== 'null')
        .map(key => {
            const id = isNaN(parseInt(base[key], 10)) ? null : parseInt(base[key], 10);
            const name = translationService
                ? translationService.translateMsg(`general.${key.charAt(0).toLowerCase() + key.slice(1)}`)
                : key.replace(/([a-z])([A-Z])/g, '$1 $2');

            return { id: id, name: name };
        });
};
